import { Value } from 'slate'

import defaultValue from './defaultValue'

export const initialValue = Value.fromJSON(defaultValue)
